<template>
  <div>
    <q-input
      v-model="searchModel"
      :debounce="600"
      :after="[
        {
          icon: null,
          handler() {
            onSearch(searchModel)
          }
        }
      ]"
      icon="none"
      color="light"
      bg-color="white"
      placeholder="Search list..."
      outlined
      dense
      input-class="search-input"
      hide-bottom-space
      @input="onSearch(searchModel)"
    />
  </div>
</template>

<script>
export default {
  name: 'LmIndexPageListBar',
  data() {
    return {
      searchModel: null
    }
  },
  methods: {
    onSearch(terms) {
      this.$emit('search', terms)
    }
  }
}
</script>

<style lang="stylus" scoped>
>>> .q-field__control {
  height 25px !important
}
.search-input {
  height 25px
}
</style>
